module.exports = __webpack_public_path__ + "img/step2.a8edb0d7.png";